/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SessionQuarantine,
  SessionQuarantine$inboundSchema,
} from "./sessionquarantine.js";

export type ListSessionQuarantinesResult = {
  /**
   * Active session quarantines.
   */
  quarantines: Array<SessionQuarantine>;
};

/** @internal */
export const ListSessionQuarantinesResult$inboundSchema: z.ZodMiniType<
  ListSessionQuarantinesResult,
  unknown
> = z.object({
  quarantines: z.array(SessionQuarantine$inboundSchema),
});

export function listSessionQuarantinesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSessionQuarantinesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSessionQuarantinesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSessionQuarantinesResult' from JSON`,
  );
}
